import { createBrowserRouter, RouterProvider } from "react-router-dom";

//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";
//core
import "primereact/resources/primereact.min.css";

import AuthLayout from "./layouts/auth/AuthLayout";
import Register from "./pages/auth/register/Register";
import Login from "./pages/auth/login/Login";
import ConfirmEmail from "./pages/auth/confirmation/ConfirmEmail";
import ForgotPassword from "./pages/auth/forgot/ForgotPassword";
import ResetPassword from "./pages/auth/reset/ResetPassword";
import DashboardLayout from "./layouts/dashboard/DashboardLayout";
import Statistic from "./pages/dashboard/statistic/Statistic";
import Users from "./pages/dashboard/users/Users";
import Candidates from "./pages/dashboard/candidates/Candidates";

//App
import "./App.css";
import "./assets/styles/main.scss";
import { routes } from "./routes";
import RequireAuth from "./gates/auth/RequireAuth";
import Notfound from "./pages/error/Notfound";
import Forbidden from "./pages/error/Forbidden";
import Landing from "./pages/website/landing/Landing";
import DeniedLogin from "./gates/auth/DeniedLogin";
import Role from "./pages/dashboard/setting/Role";
import Permission from "./pages/dashboard/setting/Permission";
import WebsiteLayout from "./layouts/website/WebsiteLayout";
import Formation from "./pages/website/Formation";
import AdmissionLayout from "./layouts/website/AdmissionLayout";
import Application from "./pages/website/admission-process/Application";
import Site from "./pages/dashboard/site/Site";
import GeneralTest from "./pages/dashboard/admission/GeneralTest";
import Requirement from "./pages/dashboard/admission/Requirement";
import Branch from "./pages/dashboard/branch/Branch";
import Training from "./pages/dashboard/training/Training";
import TestProposal from "./pages/dashboard/admission/TestProposal";
import SingleCandidate from "./pages/dashboard/candidates/SingleCandidate";
import MyCandidates from "./pages/dashboard/candidates/MyCandidates";
import ComingSoon from "./pages/website/ComingSoon";
import Profil from "./pages/dashboard/profil/Profil";
import Archivates from "./pages/dashboard/candidates/Archivates";

function App() {
  const router = createBrowserRouter([
    {
      element: <WebsiteLayout />,
      children: [
        {
          path: routes.notFound,
          element: <Notfound />,
        },
        {
          path: routes.forbidden,
          element: <Forbidden />,
        },
        {
          path: routes.home,
          element: <Landing />,
        },
        {
          path: routes.formation,
          element: <Formation />,
        },
        {
          path: routes.community,
          element: <ComingSoon />,
        },
      ],
    },

    {
      element: <DeniedLogin />,
      children: [
        {
          element: <AuthLayout />,
          path: routes.auth,
          children: [
            {
              path: routes.login,
              element: <Login />,
            },
            {
              path: routes.register,
              element: <Register />,
            },
            {
              path: routes.forgotPassword,
              element: <ForgotPassword />,
            },
            {
              path: routes.resetPassword,
              element: <ResetPassword />,
            },
          ],
        },
      ],
    },
    {
      element: (
        <RequireAuth
          allowedPermissions={[
            "gerer_profil",
            "soumettre_candidature",
            "consulter_les_programmes",
            "suivre_l_etat_de_la_candidature",
            "acceder_aux_resultats",
            "passer_test_de_profil",
            "passer_test_de_developpement_personnel",
            "gerer_les_informations_personnelles",
          ]}
        />
      ),
      children: [
        {
          element: <AdmissionLayout />,
          children: [
            {
              path: routes.application.application,
              element: <Application />,
            },
          ],
        },
        {
          element: <DashboardLayout />,
          //path: routes.dashboard.defaultPath,
          children: [
            {
              path: routes.dashboard.mycandidates.path,
              element: <MyCandidates />,
            },
          ],
        },
      ],
    },
    {
      element: (
        <RequireAuth
          allowedPermissions={[
            "traiter_candidature",
            "acceder_aux_resultats",
            "donner_une_appreciation",
          ]}
        />
      ),
      children: [
        {
          element: <DashboardLayout />,
          children: [
            {
              path: routes.dashboard.candidates.path,
              element: <Candidates />,
            },
            {
              path: routes.dashboard.candidateArchives.path,
              element: <Archivates />,
            },
            {
              path: routes.dashboard.singleCandidates.path,
              element: <SingleCandidate />,
            },
          ],
        },
      ],
    },
    {
      element: (
        <RequireAuth
          allowedPermissions={[
            "gerer_candidatures",
            "gerer_admissions",
            "gerer_parcours",
            "gerer_sites_ou_campus_admission",
            "gerer_outils_tests_developpement_personnel",
            "gerer_utilisateurs_roles_permissions",
            "generer_rapports_statistiques_candidatures",
          ]}
        />
      ),
      children: [
        {
          element: <DashboardLayout />,
          children: [
            {
              path: routes.dashboard.statistic.path,
              element: <Statistic />,
            },
            {
              path: routes.dashboard.users.path,
              element: <Users />,
            },
            {
              path: routes.dashboard.role.path,
              element: <Role />,
            },
            {
              path: routes.dashboard.permission.path,
              element: <Permission />,
            },
            {
              path: routes.dashboard.branches.path,
              element: <Branch />,
            },
            {
              path: routes.dashboard.trainings.path,
              element: <Training />,
            },
            {
              path: routes.dashboard.sites.path,
              element: <Site />,
            },
            {
              path: routes.dashboard.generalTest.path,
              element: <GeneralTest />,
            },
            {
              path: routes.dashboard.proposals.path,
              element: <TestProposal />,
            },
            {
              path: routes.dashboard.requirement.path,
              element: <Requirement />,
            },
          ],
        },
      ],
    },
    {
      element: (
        <RequireAuth
          allowedPermissions={[
            "gerer_candidatures",
            "gerer_admissions",
            "gerer_parcours",
            "gerer_sites_ou_campus_admission",
            "gerer_outils_tests_developpement_personnel",
            "gerer_utilisateurs_roles_permissions",
            "generer_rapports_statistiques_candidatures",
            "traiter_candidature",
            "acceder_aux_resultats",
            "donner_une_appreciation",
            "gerer_profil",
            "soumettre_candidature",
            "consulter_les_programmes",
            "suivre_l_etat_de_la_candidature",
            "acceder_aux_resultats",
            "passer_test_de_profil",
            "passer_test_de_developpement_personnel",
            "gerer_les_informations_personnelles",
          ]}
        />
      ),
      children: [
        {
          element: <DashboardLayout />,
          children: [
            {
              path: routes.dashboard.profil.path,
              element: <Profil />,
            },
          ],
        }
      ],
    },
    {
      path: routes.confirmEmail,
      element: <ConfirmEmail />,
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
